export default {
    sha: '5d7eb6da88305fe003d05b84bbd1c8dc896f45f8',
    buildNumber: 'undefined',
}
